import { useEffect, useState } from "react";
import contactHttpClient from "utils/contactHttpClient";

export function useGetInvoicePaymentDetails(
  invoiceId?: string | null,
  recipientId?: string | null,
) {
  const [paymentDetails, setPaymentDetails] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  async function fetchInvoicePaymentDetails() {
    if (!invoiceId || !recipientId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await contactHttpClient.get(
        `/payments/invoice/${invoiceId}/${recipientId}`,
      );
      setPaymentDetails(result.data);
    } catch (err) {
      setError(err);
      setPaymentDetails(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchInvoicePaymentDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId]);

  return { paymentDetails, loading, error, fetchInvoicePaymentDetails };
}
